import axios from 'axios';
import {MsalService} from '@ey/voltron-core';
import queryString from 'query-string';

/**
 * Redux Middleware for getting login hint cookie from server
 * This middleware will be used to get login hint cookie (if available on server) and set user context state
 * This context used by authentication middleware in order to perform silent SSO
 */
const loginContextMiddleware = (config) => (store) => (next) => (action) => {
	if (action.type !== 'HOME_LOGIN') {
		return next(action);
	}

	//skip and pass action to next middleware if user is logged in already
	const authService = new MsalService(config);
	if (authService.isLoggedIn()) {
		return next(action);
	}

	let queryStringParams = queryString.parse(window.location.search);
	// set login_hint if it is passed as querystring
	// this is for the scenario where external user is logging into internal apps as guest user
	// and there are multiple identities
	// this will help us set the login_hint for id_token so that the user is not prompted
	if (queryStringParams && queryStringParams.login_hint) {
		// querystring for login_hint is sent as base64 encoded
		// test if the login_hint is base64
		const b64regex = /(?:^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$)/;
		// test if login_hint is valid email
		const emailregex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

		let isEncoded = b64regex.test(queryStringParams.login_hint);
		let validemail = '';

		if (isEncoded) {
			// use login_hint only if decoded base64 is valid email
			try {
				let decodedHint = atob(queryStringParams.login_hint);
				validemail = emailregex.test(decodedHint) ? decodedHint : '';
			} catch (e) {
				console.log('BTOA error', e);
				validemail = emailregex.test(queryStringParams.login_hint) ? queryStringParams.login_hint : '';
			}
		} else {
			// use login_hint only if it is valid email
			validemail = emailregex.test(queryStringParams.login_hint) ? queryStringParams.login_hint : '';
		}
		if (validemail) {
			authService.setLoginHint(isEncoded ? atob(queryStringParams.login_hint) : queryStringParams.login_hint);
			return next(action);
		}
	}

	return axios
		.get('/getloginHint')
		.then(function(response) {
			console.log('$loginContextMiddleware - Get login hint cookie', response.data);
			if (response.data) {
				authService.setLoginHint(response.data);
			}
		})
		.catch((error) => {
			console.log('$loginContextMiddleware - Error in getting login hint cookie', error);
		})
		.finally(() => {
			return next(action);
		});
};

export default loginContextMiddleware;
